export default __webpack_public_path__ + "static/media/05_OrangeAndBlack.81a51bbf.png";